'use client'

import { useState } from 'react'
import { useAuth } from '@/lib/auth-context'
import Link from 'next/link'

export default function RegisterPage() {
  const { register } = useAuth()

  const [name,                 setName]                = useState('')
  const [email,                setEmail]               = useState('')
  const [password,             setPassword]            = useState('')
  const [passwordConfirmation, setPasswordConfirmation]= useState('')
  const [error,                setError]               = useState('')
  const [loading,              setLoading]             = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password !== passwordConfirmation) {
      setError('Wachtwoorden komen niet overeen.')
      return
    }

    setLoading(true)
    try {
      await register(name, email, password, passwordConfirmation)
    } catch (err: any) {
      const errors = err.response?.data?.errors
      if (errors) {
        const firstError = Object.values(errors)[0] as string[]
        setError(firstError[0])
      } else {
        setError('Registratie mislukt. Probeer het opnieuw.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full space-y-8">

        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900">
            MoveFit by Nanda
          </h1>
          <h2 className="mt-2 text-xl text-gray-600">
            Account aanmaken
          </h2>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white shadow rounded-lg p-8 space-y-6"
        >
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Naam
            </label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2
                         focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="Jouw naam"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              E-mailadres
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2
                         focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="jouw@email.nl"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Wachtwoord
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2
                         focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="Minimaal 8 tekens"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Wachtwoord bevestigen
            </label>
            <input
              type="password"
              required
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2
                         focus:outline-none focus:ring-2 focus:ring-orange-500"
              placeholder="Herhaal wachtwoord"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300
                       text-white font-semibold py-2 px-4 rounded-lg transition-colors"
          >
            {loading ? 'Account aanmaken...' : 'Account aanmaken'}
          </button>

          <p className="text-center text-sm text-gray-600">
            Al een account?{' '}
            <Link href="/login" className="text-orange-500 hover:underline">
              Log hier in
            </Link>
          </p>
        </form>

      </div>
    </div>
  )
}
